"use client";

import dynamic from "next/dynamic";
import * as Sentry from "@sentry/nextjs";
import { isChunkLoadError } from "@/lib/chunk-reload";
import { renderNothingIfChunkFails } from "@/lib/optional-chunk";
import type { UpgradeClientAction } from "@/lib/sentry/capture-upgrade-client";

export const LazyUpgradeQuoteModal = dynamic(
  () =>
    renderNothingIfChunkFails(
      import("./UpgradeQuoteModal")
        .then((mod) => mod.UpgradeQuoteModal)
        .catch((error: unknown) => {
          if (isChunkLoadError(error)) {
            const action = "chunk_load" satisfies UpgradeClientAction;
            Sentry.captureException(error, {
              fingerprint: ["upgrade-flow-client", action],
              tags: { surface: "upgrade_flow", route: "upgrade_modal", action },
            });
          }
          throw error;
        }),
    ),
  { ssr: false },
);
